import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable, Subscription } from 'rxjs'
import { filter, take, tap } from 'rxjs/operators'
import { BreadcrumbService } from '../../services/breadcrumb.service'
import { BaseNavStateComponent, JmlNavAdapterService, JmlUrlParamService } from '../../modules/navigation-state'
import { TableData } from '../../modules/dto'
import { LocalBackendMiscDataStorageService } from '../../services/local-backend-misc-data-storage.service'
import { JmlTitleService } from '../../services/jml-title.service'
import { EmptyState } from '../../models/state/empty-state'

@Component({
  selector: 'jml-lib-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss']
})
export class RoleManagementComponent extends BaseNavStateComponent<EmptyState> implements OnInit {
  tableData: TableData

  token$: Observable<string>
  id$: Observable<string>

  entryId: number
  isSingleRole: boolean

  private readonly SINGLE_ROLE_TYPE = 'ROLE_TYPES.ROLE'

  constructor(
    private route: ActivatedRoute,
    private jmlNavigationService: JmlUrlParamService,
    private breadcrumbService: BreadcrumbService,
    private titleService: JmlTitleService,

    jmlNav: JmlNavAdapterService,
    router: Router
  ) {
    super(jmlNav, route, router)
  }

  ngOnInit() {
    this.breadcrumbService.setItems([{ label: 'Rollenverwaltung' }])
    this.titleService.setAppTitle('Rollenverwaltung')
    this.tableData = new TableData('SecurityRole').hideAttachments()

    const isRouteComp = true
    // will this component provide a custom identifier?
    const hasCustomComponentIdentifier = false
    // initialize pre-ngOnInit-setting for base class.
    this.initNavStateSettings(isRouteComp, hasCustomComponentIdentifier)
    super.ngOnInit()

    this.token$ = this.jmlNavigationService.readToken$(this.route).pipe(filter((token) => !!token))
    this.id$ = this.jmlNavigationService.readIdFromQueryParams$(this.route).pipe(filter((id) => !!id))
  }

  onEntitySelection(entry) {
    if (!entry) {
      this.isSingleRole = undefined
      this.entryId = undefined
    } else {
      this.entryId = entry.id
      this.isSingleRole = entry.typeId?.hrid === this.SINGLE_ROLE_TYPE
    }
  }
}
